import {notification} from "../helpers/notification";

if (notificationBlock) {
    if (notificationBlock == 'error') {
        notification('error', 'Sorry, something went wrong. We are working on it and we\'ll get it fixed as soon as we can')
    } else {
        notification('success', 'Your successfully block notification.')
    }
}

$('.datepicker-mob').datepicker({
    format: 'M dd yy',
    autoclose: 1,
    disableTouchKeyboard: true,
    orientation: "top right",
    startDate: '+1d'
})

$('.datepicker-home').datepicker({
    format: 'M dd yy',
    autoclose: 1,
    orientation: "bottom left",
    startDate: '+1d'
})

$(document).ready(function () {
    $('#logoutButton').on('click', function(){
        $('#logout-form').submit();
        $('#logoutButton').attr('disabled', true);
    });

    $('.js-key-submit').keyup(function (e) {
        if (e.keyCode === 13) {
            $('#search-form').submit();
        } else {
            $('.wrapper-mobile-full-search').addClass('open')
        }
    });
    if ($(window).width() > 1025) {
        $('.js-close-mob-full-search').click(function (e) {
            $('.wrapper-mobile-full-search').removeClass('open')
            $('body').css('overflow', 'auto')
        })
        $(document).on('click', '.js-location-input-full-mob', function (e) {

        })
    }

    $('.js-submit-search').on('click', function () {
        $('#search-form').submit();
    })

    $('.js-sound-value').on('input', function () {
        $('.js-sound-value').val($(this).val())
    })

    $('.js-location-value').on('input', function () {
        $('.js-location-value').val($(this).val())
    })

    $('.js-location-value').on('change', function () {
        $('.js-location-value').val($(this).val())
    })

    $('.js-date-value').on('input', function () {
        $('.js-date-value').val($(this).val())
    })

    $('.js-date-value').on('change', function () {
        $('.js-date-value').val($(this).val())
    })

    $('.lat-value').on('input', function () {
        $('.lat-value').val($(this).val())
    })

    $('.lon-value').on('input', function () {
        $('.lon-value').val($(this).val())
    })

    $('.city-value').on('input', function () {
        $('.city-value').val($(this).val())
    })

    $('.show-artist-link').hover(
        function () {
            $(this).children().addClass('show-artist__img-hover').addClass('feature-artist-avatar-hover');
        }, function () {
            $(this).children().removeClass('show-artist__img-hover').removeClass('feature-artist-avatar-hover');
        }
    );

    let smallSearch = $('.js-dashboard-full-search');
    /**
     * Detect when click in out js-mob-help-bar and hide help Bar
     * @type {*|jQuery|HTMLElement}
     */

    smallSearch.on('click', function () {
        $('#header-location').val($('#location-search').val());
        $('#location-header').attr("placeholder", "Where is the show?");
        $('#header-keywords').attr("placeholder", "What type of sound do you want?");
        $('#header-date').attr("placeholder", "When is the show?");
    })
})
